import { Injectable, Inject } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';

import { UtilisateurService } from '../services/utilisateur.service';

import { Roles } from '../tools/Roles';
/**
 * Guard fournisseur
 * @implements CanActivate
 */
@Injectable({
  providedIn: 'root'
})
export class FournisseurGuard implements CanActivate {

    /**
     * Constructeur
     * @param utilisateurService
     * @param router
     */
    constructor(@Inject(UtilisateurService) private utilisateurService: UtilisateurService, private router: Router) {
    }

    /**
     * Gestion de l'autorisation
     * @param next
     * @param state
     */
    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean>
    {
        let obs = this.utilisateurService.obtenirUtilisateurCourant();
        return obs.toPromise().then((retour: any) => {
            if (retour && retour.Result) {
                // Redirection vers la page d'erreur si l'utilisateur n'a pas de fournisseurs
                if (!retour.Result.ListeFournisseurs || retour.Result.ListeFournisseurs.length == 0) {
                    // V�rification si l'utilisateur est interne
                    if (!(retour.Result.RolesGlobaux && retour.Result.RolesGlobaux.indexOf(Roles.MRInterne) >= 0)){
                        this.router.navigate(['/erreur4031']);
                        return false;
                    }
                }
            }
            return true;
        });
    }
}
